/* Confirmed native contact enquiries only. No form field values are collected. */
(() => {
  'use strict';
  if (window.zagoEnquiryInstalled) return;
  window.zagoEnquiryInstalled = true;
  const shopify = window.Shopify;
  if (!shopify || shopify.designMode || !shopify.theme || shopify.theme.role !== 'main') return;

  const measurementId = 'G-EETPC6L11P';
  const maxAge = 30 * 60 * 1000;
  const consentAllowed = () => !!(shopify.customerPrivacy && shopify.customerPrivacy.analyticsProcessingAllowed());
  const markers = [...document.querySelectorAll('[data-zago-enquiry]')];
  const keyFor = marker => 'zago:enquiry:' + marker.dataset.formId;
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) { /* Storage may be disabled. */ } };

  function record(marker) {
    const key = keyFor(marker);
    if (!consentAllowed()) { remove(key); return; }
    let pending;
    try { pending = JSON.parse(sessionStorage.getItem(key)); } catch (_) { return; }
    if (!pending || pending.path !== location.pathname || Date.now() - pending.at < 0 || Date.now() - pending.at > maxAge) {
      remove(key);
      return;
    }
    // Consume before queueing so reloads and repeated consent events cannot double count.
    remove(key);
    const cleanLocation = location.origin + location.pathname;
    if (!window.zagoEnquiryTag) {
      window.zagoEnquiryLayer = [];
      window.zagoEnquiryTag = function () { window.zagoEnquiryLayer.push(arguments); };
      const tag = window.zagoEnquiryTag;
      tag('consent', 'default', { analytics_storage: 'granted', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
      tag('js', new Date());
      // The Google & YouTube app already owns pageviews. This tag sends only enquiries.
      tag('config', measurementId, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false, page_location: cleanLocation, page_referrer: '' });
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + measurementId + '&l=zagoEnquiryLayer';
      document.head.appendChild(script);
    }
    window.zagoEnquiryTag('event', 'generate_lead', {
      send_to: measurementId,
      form_id: marker.dataset.formId,
      lead_type: 'contact_enquiry',
      language: marker.dataset.locale,
      page_location: cleanLocation,
      page_referrer: ''
    });
  }

  for (const marker of markers) {
    const form = marker.closest('form');
    if (!form) continue;
    form.addEventListener('submit', () => {
      const key = keyFor(marker);
      if (!form.checkValidity() || !consentAllowed()) { remove(key); return; }
      try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), path: location.pathname })); } catch (_) { /* Fail closed when storage is blocked. */ }
    });
  }

  const checkConfirmed = () => {
    if (window.zagoEnquiryTag && shopify.customerPrivacy) {
      window.zagoEnquiryTag('consent', 'update', {
        analytics_storage: consentAllowed() ? 'granted' : 'denied',
        ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied'
      });
    }
    for (const marker of markers) if (marker.dataset.confirmed === 'true') record(marker);
  };
  document.addEventListener('visitorConsentCollected', checkConfirmed);
  const ready = () => {
    if (shopify.customerPrivacy) checkConfirmed();
    else if (shopify.loadFeatures) shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) checkConfirmed(); });
  };
  ready();
  window.addEventListener('load', ready, { once: true });
})();
